import { Directive, HostListener, input } from '@angular/core';

@Directive({
  selector: 'input[noWhitespace]'
})
export class NoWhitespaceDirective {
  readonly noWhitespace = input<boolean>(true);

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (!this.noWhitespace()) return;

    if (event.key === ' ' || event.code === 'Space') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (!this.noWhitespace()) return;

    const input = event.target as HTMLInputElement;
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text');
    if (!pastedText) return;

    const cleanedText = pastedText.replace(/\s/g, '');
    if (!cleanedText) return;

    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    input.setRangeText(cleanedText, start, end, 'end');
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
